import 'css-chunksrc/client/scenes/notifications/notification/breadcrumbs/styles.scss';export default {
  "breadcrumbs": "_breadcrumbs_iy84l_1",
  "breadcrumb": "_breadcrumb_iy84l_1",
  "separator": "_separator_iy84l_32"
};